/* SOLVEY · Motion
   ------------------------------------------------------------------
   Zet binnenscroll-animaties en micro-interacties op de eigen secties.
   Zie de kop van solvey-motion.css voor het waarom.

   Uitgangspunten:
   - Niets boven de vouw. De hero is het LCP-element; die animeren kost
     score en levert niets op (je ziet 'm toch al).
   - Geen harde sectie-ID's. Die verschillen per omgeving (live vs dev),
     dus we bepalen bij het laden wélke secties onder de vouw beginnen.
   - Faalt er iets, dan staat alles zichtbaar. Nooit een lege pagina.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var cfg = window.SOLVEY_MOTION || {};
  var html = document.documentElement;

  // Respecteer de systeemvoorkeur. Niets aanzetten = alles gewoon zichtbaar.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Oude browser zonder IntersectionObserver: overslaan, niet forceren.
  if (!('IntersectionObserver' in window)) return;

  var MAX_STAGGER = 6;   // verder tellen laat de laatste kaart te lang wachten
  var MIN_GRID    = 3;   // pas stagger vanaf 3 gelijksoortige buren

  function markeer() {
    var secties = document.querySelectorAll('.shopify-section');
    if (!secties.length) return false;

    var vouw = window.innerHeight || 800;
    var gevonden = 0;

    Array.prototype.forEach.call(secties, function (sectie) {
      var rect = sectie.getBoundingClientRect();
      var top = rect.top + (window.pageYOffset || 0);

      // Boven de vouw of leeg: met rust laten.
      if (top < vouw || rect.height < 40) return;

      // Sticky/fixed elementen nooit verschuiven — die horen niet mee te
      // bewegen en een transform op een voorouder breekt position:fixed.
      var pos = window.getComputedStyle(sectie).position;
      if (pos === 'fixed' || pos === 'sticky') return;

      // ⚠️ En ook niet als er ergens BINNENIN iets sticky of fixed staat.
      // Een transform op een voorouder maakt een containing block, waardoor
      // zo'n kind ineens t.o.v. de sectie gaat staan i.p.v. het scherm. Dat
      // sloopt de sticky koopbalk, de filterbalk van de kennishub en de
      // drawers. Site-breed is dit de belangrijkste guard.
      if (heeftVastKind(sectie)) return;

      var rij = gridKind(sectie);
      if (rij) {
        rij.setAttribute('data-sv-stagger', '');
        Array.prototype.forEach.call(rij.children, function (kind, i) {
          kind.style.setProperty('--sv-i', Math.min(i, MAX_STAGGER));
        });
        observer.observe(rij);
      }

      sectie.setAttribute('data-sv-reveal', '');
      observer.observe(sectie);
      gevonden++;
    });

    return gevonden > 0;
  }

  // Staat er ergens in deze sectie een sticky of fixed element? Dan blijft de
  // hele sectie ongeanimeerd. Bewust ruim: liever een sectie te weinig in
  // beweging dan een koopbalk die niet meer meescrolt.
  function heeftVastKind(sectie) {
    var kandidaten = sectie.querySelectorAll('*');
    var n = Math.min(kandidaten.length, 400); // plafond: geen trage sweep op zware pagina's
    for (var i = 0; i < n; i++) {
      var pos = window.getComputedStyle(kandidaten[i]).position;
      if (pos === 'fixed' || pos === 'sticky') return true;
    }
    return false;
  }

  // Zoekt binnen een sectie de container die er als een kaartenrij uitziet:
  // minstens MIN_GRID kinderen die even breed zijn. Zo hoeven we geen
  // klassenamen van Foxify te kennen, die per build hashen.
  function gridKind(sectie) {
    var kandidaten = sectie.querySelectorAll('ul, div');
    for (var i = 0; i < kandidaten.length; i++) {
      var el = kandidaten[i];

      // Nooit in een carrousel. Swiper zet zijn slides met transform neer;
      // er een tweede transform bovenop leggen laat de rail verspringen.
      // De sectie als geheel faden geeft hier hetzelfde effect, zonder risico.
      if (el.classList.contains('swiper-wrapper') || el.closest('.swiper, .swiper-wrapper')) continue;

      var kinderen = el.children;
      if (kinderen.length < MIN_GRID || kinderen.length > 12) continue;

      var display = window.getComputedStyle(el).display;
      if (display !== 'grid' && display !== 'flex') continue;

      var eerste = kinderen[0].getBoundingClientRect();
      if (eerste.width < 80 || eerste.height < 80) continue;

      // Alle kinderen ongeveer even breed? Dan is het een rij, geen willekeurige wrapper.
      var gelijk = true;
      for (var j = 1; j < kinderen.length; j++) {
        var b = kinderen[j].getBoundingClientRect().width;
        if (Math.abs(b - eerste.width) > 2) { gelijk = false; break; }
      }
      if (gelijk) return el;
    }
    return null;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('sv-in');
      observer.unobserve(entry.target);
    });
  }, {
    // Iets vóór de onderrand starten, zodat de beweging al loopt als het
    // element echt in beeld komt in plaats van er zichtbaar op te wachten.
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.01
  });

  // Gebieden waar beweging niet hoort: navigatie, footer, drawers en de
  // sticky koopbalk. Daar leidt het af of het botst met bestaande logica.
  var VERBODEN = 'header, footer, nav, .drawer-menu, .quick-cart, [class*="sticky-atc"], [class*="launch-bar"]';

  function inVerbodenGebied(el) {
    return !!el.closest(VERBODEN);
  }

  // Micro-interacties: kaarten optillen, beeld inzoomen, knoppen indrukken.
  function microInteracties() {
    if (cfg.hover === false) return;

    // Zoom: elk beeld dat in een link zit, krijgt een zoom binnen zijn kader.
    // Dit is veilig in een carrousel, want alleen de <img> beweegt — de slide
    // zelf blijft staan waar swiper 'm neerzet.
    var beelden = document.querySelectorAll('a img, button img');
    Array.prototype.forEach.call(beelden, function (beeld) {
      var kader = beeld.parentElement;
      if (!kader || inVerbodenGebied(beeld)) return;
      if (beeld.width < 80 || beeld.height < 80) return;
      kader.setAttribute('data-sv-zoom', '');
    });

    // Optillen: alleen op kaarten die NIET in een carrousel zitten. Swiper
    // positioneert zijn slides met transform; er een tweede transform op
    // zetten laat de rail verspringen. Zie de swiper-safe regel in het
    // project: nooit stylen op .swiper-wrapper of .swiper-slide.
    var kaarten = document.querySelectorAll(
      '.card, [class*="__card"], [class*="-card"], .product-card, [class*="product-item"]'
    );
    Array.prototype.forEach.call(kaarten, function (kaart) {
      if (inVerbodenGebied(kaart)) return;
      if (kaart.closest('.swiper, .swiper-wrapper, .swiper-slide')) return;
      if (kaart.closest('[data-sv-lift]')) return;
      if (kaart.classList.contains('swiper-slide')) return;
      kaart.setAttribute('data-sv-lift', '');
    });

    var knoppen = document.querySelectorAll(
      'button, .button, [class*="__btn"], a[class*="button"]'
    );
    Array.prototype.forEach.call(knoppen, function (knop) {
      if (inVerbodenGebied(knop)) return;
      knop.setAttribute('data-sv-press', '');
    });
  }

  function start() {
    html.classList.add('sv-motion');

    var raakVlak = markeer();
    microInteracties();

    // Niets gevonden om te animeren? Dan de begintoestand meteen opheffen.
    if (!raakVlak) html.classList.add('sv-motion-off');

    // Inhaalslag. Spring je in één keer naar beneden — anker-link, terugknop
    // die de scrollpositie herstelt, of scrollTo — dan komen de secties
    // ertussen nooit door de viewport en vuurt de observer daar dus nooit.
    // Die zouden op opacity 0 blijven staan tot je er terug langs scrolt.
    // Deze sweep toont alles wat je al voorbij bent.
    var gepland = false;
    function haalIn() {
      gepland = false;
      var wachtenden = document.querySelectorAll('[data-sv-reveal]:not(.sv-in), [data-sv-stagger]:not(.sv-in)');
      Array.prototype.forEach.call(wachtenden, function (el) {
        // Bovenkant al voorbij de onderrand van het scherm = gemist.
        if (el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add('sv-in');
          observer.unobserve(el);
        }
      });
    }
    window.addEventListener('scroll', function () {
      if (gepland) return;
      gepland = true;
      window.requestAnimationFrame(haalIn);
    }, { passive: true });

    // En één keer na het laden, voor het geval de pagina al gescrold opent.
    window.setTimeout(haalIn, 1200);

    // Verandert de paginahoogte zonder dat er gescrold wordt — de quiz die
    // een stap verder gaat, een drawer die sluit, een app die tekst
    // laat inladen — dan kan een sectie ineens in beeld staan zonder dat de
    // observer of de scroll-sweep is afgegaan. Dan alsnog inhalen.
    if ('ResizeObserver' in window) {
      var vorigeHoogte = document.body.scrollHeight;
      var hoogteWatcher = new ResizeObserver(function () {
        var nu = document.body.scrollHeight;
        if (Math.abs(nu - vorigeHoogte) < 40) return;
        vorigeHoogte = nu;
        window.requestAnimationFrame(haalIn);
      });
      hoogteWatcher.observe(document.body);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
